<template>
  <div class="mb-2">
    <b-row>
      <b-col
        lg="6"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 736 145"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.9579 144L1 128.5V9H670.5L682.424 1H735V9V128.5L715.5 144H32.9579Z"
            stroke="#00B058"
          />
          <path
            d="M674 1H678L667 8H663L674 1Z"
            fill="#00B058"
          />
          <path
            d="M667 1H671L660 8H656L667 1Z"
            fill="#00B058"
          />
          <path
            d="M660 1H664L653 8H649L660 1Z"
            fill="#00B058"
          />
          <path
            d="M653 1H657L646 8H642L653 1Z"
            fill="#00B058"
          />
          <path
            d="M646 1H650L639 8H635L646 1Z"
            fill="#00B058"
          />
          <path
            d="M639 1H643L632 8H628L639 1Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count1.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">ปริมาณยานพาหนะทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="460"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:45px">
              {{ Total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:25px;"
            >
              คัน/วัน
            </span>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="6"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 736 145"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.9579 144L1 128.5V9H670.5L682.424 1H735V9V128.5L715.5 144H32.9579Z"
            stroke="#00B058"
          />
          <path
            d="M674 1H678L667 8H663L674 1Z"
            fill="#00B058"
          />
          <path
            d="M667 1H671L660 8H656L667 1Z"
            fill="#00B058"
          />
          <path
            d="M660 1H664L653 8H649L660 1Z"
            fill="#00B058"
          />
          <path
            d="M653 1H657L646 8H642L653 1Z"
            fill="#00B058"
          />
          <path
            d="M646 1H650L639 8H635L646 1Z"
            fill="#00B058"
          />
          <path
            d="M639 1H643L632 8H628L639 1Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count2.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">ยานพาหนะสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="385"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
            <span style="text-align:left; font-weight: 700; font-size:45px">
              {{ Type_Max }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:25px;"
            >
              คัน/วัน
            </span>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
  // BPopover,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    // BPopover,
  },
  data() {
    return {
      Total: '',
      Type_Max: '',
      Type: '',
      Speed_Max: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumCount()
    this.interval = setInterval(() => {
      this.getSumCount()
    }, 300000)
  },
  methods: {
    getSumCount() {
      axios
        .post('/getSumCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.Total = response.data[0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Type_Max = response.data[0].Type_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Max = response.data[0].Speed_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

          if (response.data[0].Type_Max === response.data[0].Bike && response.data[0].Type_Max !== 0) {
            this.Type = 'จักรยานยนต์'
          } else if (response.data[0].Type_Max === response.data[0].Car && response.data[0].Type_Max !== 0) {
            this.Type = 'รถยนต์'
          } else if (response.data[0].Type_Max === response.data[0].Truck && response.data[0].Type_Max !== 0) {
            this.Type = 'รถบรรทุก'
          } else if (response.data[0].Type_Max === response.data[0].Bus && response.data[0].Type_Max !== 0) {
            this.Type = 'รถบัส'
          } else if (response.data[0].Type_Max === response.data[0].Taxi && response.data[0].Type_Max !== 0) {
            this.Type = 'รถแท็กซี่'
          } else if (response.data[0].Type_Max === response.data[0].Pickup && response.data[0].Type_Max !== 0) {
            this.Type = 'รถกระบะ'
          } else if (response.data[0].Type_Max === response.data[0].Trailer && response.data[0].Type_Max !== 0) {
            this.Type = 'รถพ่วง'
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
